<template>
    <aside id="sidebarMenu" class="sidebar" :class="{'collapsed' : layout_controller.menu_collapsed, 'toggled' : layout_controller.menu_toggled}">
        <div class="sidebar-layout">
            <div class="sidebar-header">

                <PTMailWarningVersion v-if="version_controller.data.is_waning_visible" />

                <router-link to="/compose" @click="onDismissMenu()">
                    <span class="menu-icon" :data-tooltip-visible="layout_controller.menu_collapsed" v-tooltip="'menu.items.compose'">
                        <i class="fas fa-pencil-alt"></i>
                    </span>
                    <span class="menu-title">{{Language.say('menu.items.compose')}}</span>
                </router-link>
            </div>
            <div class="sidebar-content" v-smart-render-scroll>
                <nav class="menu">
                    <!--<li class="menu-item drag-over"-->
                    <div v-for="(folder) in folders_controller.mailboxes.folders.main.items"
                      class="menu-item"
                      v-drag-drop="{
                        drop_data: folder,
                        drop_suffix: 'sidebar',
                        hover_events: [drag_event_message_list],
                      }"
                      :key='folder.id'
                      :class="{
                        ['depth-' + folder.level] : true
                      }"
                    >
                        <FolderItemCollapsable
                          @click="onDismissMenu()"
                          :folder="folder"
                          :folders_collapse_collection='folders_collapse_collection'
                          @folderContextMenu="onFolderContextMenu"
                          :show_tooltips="layout_controller.menu_collapsed"
                        />
                    </div>
                    <ul>
                        <li
                          class="menu-item sub-menu"
                          :class="{'open' : layout_controller.menu_folders_collapsed === false}"
                          :data-tooltip-visible="layout_controller.menu_collapsed"
                          v-tooltip="'menu.items.folders'"
                          >
                          <div
                              v-drag-drop="{
                                drop_data: top_folder_item,
                                drop_suffix: 'sidebar',
                                hover_events: [drag_event_sidebar_folder, drag_event_folder_section]
                              }"
                            >
                            <span v-if="folders_collapse_collection.count"
                              @click="onSubFoldersToggle()"
                              class="sub-menu-icon"
                              role="button"
                            >
                                <i class="fas" :class="{
                                    'fa-chevron-right': (layout_controller.menu_folders_collapsed),
                                    'fa-chevron-down' : (!layout_controller.menu_folders_collapsed)}">
                                </i>
                            </span>
                            <router-link to="/folders"
                              @click="onDismissMenu()"
                              v-context-menu="{action: onFolderMainContextAction}"
                              >
                                <span class="menu-icon">
                                    <i class="fas fa-folder"></i>
                                </span>
                                <span class="menu-title">
                                  {{Language.say('menu.items.folders')}}
                                  <i v-if="folders_controller.section_state.loading['fetch_background']" class="fas fa-redo-alt fa-spin" aria-hidden="true"></i>
                                </span>
                                <span v-if="folders_controller.mailboxes.folders.custom.unread" class="counter">{{folders_controller.mailboxes.folders.custom.unread}}</span>

                                <!-- <span class="action-progress"></span> -->
                            </router-link>
                          </div>

                          <div v-if="(layout_controller.menu_folders_collapsed === false)
                             && folders_collapse_collection.count" class="sub-menu-list">
                                <FoldersListCollapsable
                                  ref="folders_collapse_element"
                                  list_type="router"
                                  list_class="menu-list"
                                  item_class="menu-item"
                                  drag_drop_suffix="sidebar"
                                  :drag_start_event="drag_event_sidebar_folder"
                                  :drag_drop_events="[drag_event_message_list, drag_event_sidebar_folder, drag_event_folder_section]"
                                  :folders_collapse_collection='folders_collapse_collection'
                                  :folders_selection_collection='folders_selection_collection'
                                  :folders_disabled="folders_disabled"
                                  @folderContextMenu="onFolderContextMenu"
                                  @folderClick="onDismissMenu()"
                                />
                          </div>

                          <div v-else-if="folders_controller.section_state.loading['fetch_all']" class="loader">
                              <i class="fas fa-redo-alt fa-spin" aria-hidden="true"></i>
                              <span>{{Language.say('menu.items.loading')}}</span>
                          </div>

                          <ContextMenu ref="context_menu_component">
                            <template #menu_items>
                                <FoldersContextActions
                                    :webmail_view="webmail_view"
                                    :context_folder='context_folder'
                                    :state_initiator="initiator"
                                    block="sidebar_context_menu_actions"
                                />
                            </template>S
                          </ContextMenu>
                        </li>
                        <li class="menu-item" :class="item.list_class" v-for="item in menu_items" :key="item.text">
                            <router-link :to="item.link" @click="onDismissMenu()">
                                <span class="menu-icon" :data-tooltip-visible="layout_controller.menu_collapsed" v-tooltip="item.text">
                                    <i :class="item.icon"></i>
                                </span>
                                <span class="menu-title">{{Language.say(item.text)}}</span>
                                <!-- <span class="badge-new">Novo</span> -->
                            </router-link>
                        </li>
                    </ul>
                </nav>
            </div>
        </div>
    </aside>

    <ContextMenu ref="context_folder_component">
        <template #menu_items>
            <FolderSidebarContextActions
              :webmail_view="webmail_view"
              :state_initiator="initiator"
              :folders_collapse_collection='folders_collapse_collection' />
        </template>
    </ContextMenu>

    <div id="overlay" @click="onDismissMenu();" class="overlay"></div>

    <DragDrop
      ref="ref_dragdrop_folders"
      event_name="drag-sidebar-folder-list"
      :icon="{single: 'fas fa-folder'}"
      :message="{single: 'folders.move.drag_move_folder'}"
      :dragdrop_controller="dragdrop_controller"></DragDrop>
</template>

<script setup>
  import {ref, reactive, watch}       from 'vue';
  import {onBeforeMount}              from 'vue';
  import {defineProps, onMounted}     from 'vue';
  import {onUnmounted}                from 'vue';
  import {useRouter}                  from 'vue-router';
  import FoldersContextActions        from '@/vue/Views/Folders/Partials/FoldersContextActions.vue'
  import ContextMenu                  from '@/vue/Elements/Tools/ContextMenu.vue';
  import FolderItemCollapsable        from '@/vue/Views/Folders/Partials/FolderItemCollapsable.vue';
  import FoldersListCollapsable       from '@/vue/Views/Folders/Partials/FoldersListCollapsable.vue';
  import FolderSidebarContextActions  from '@/vue/Views/Folders/Partials/FolderSidebarContextActions.vue';
  import PTMailWarningVersion         from '@/vue/Elements/Tools/PTMailWarningVersion.vue';
  import LayoutSettingsController     from '@/js/Webmail/LayoutSettingsController.js';
  import DragDropController           from "@/js/Webmail/DragDrop/DragDropController";
  import FoldersController            from '@/js/Mailboxes/FoldersController.js';
  import FoldersCollapseCollection    from '@/js/Mailboxes/Collections/FoldersCollapseCollection';
  import Language                     from '@/js/Shared/Language/Language.js';
  import CollectionList               from '@/js/Shared/Collections/CollectionList';
  import VersionController            from '@/js/Webmail/VersionController';
  import DragDrop                     from '@/vue/Elements/Tools/DragDrop.vue';


  const props = defineProps({
    webmail_view: {},
  })

  const menu_items = [
    {
      list_class : 'divider',
      link       : '/contacts',
      icon       : 'fas fa-address-card',
      text       : 'menu.items.contacts',
    },
    {
      link       : '/settings',
      icon       : 'fas fa-cog',
      text       : 'menu.items.settings',
    },
    {
      link       : '/logout',
      icon       : 'fas fa-sign-out-alt',
      text       : 'menu.items.logout',
    },
  ]

  const folders_collapse_collection  = reactive(new FoldersCollapseCollection('sidebar_menu'));
  const folders_selection_collection = reactive(new CollectionList('id'));
  const context_menu_component       = ref();
  const context_folder_component     = ref();
  const folders_collapse_state       = ref(false);
  const menu_hide_state              = ref(false)
  const folders_disabled             = ref({});
  const ref_dragdrop_folders         = ref();
  const top_folder_item              = ref();

  const context_folder               = ref();
  const layout_controller            = LayoutSettingsController;
  const folders_controller           = FoldersController;
  const version_controller           = VersionController;
  const dragdrop_controller          = DragDropController;
  const initiator                    = 'siderbar_menu';
  const drag_event_sidebar_folder    = 'drag-sidebar-folder-list';
  const drag_event_folder_section    = 'drag-folder-list';
  const drag_event_message_list      = 'drag-message-list';
  const router                       = useRouter();

  watch(() => folders_controller.collection_state.last_changed, () => {
    setCollectionLists();
  });

  onBeforeMount(() => {
    folders_controller.section_state.onLoad('fetch_all', async () => {
      setCollectionLists();
    })
    setTopFolder();
  })

  onMounted(() => {
    dragdrop_controller.broadcaster.on(`${drag_event_message_list}-start`, onDragStartMessage);
    dragdrop_controller.broadcaster.on(`${drag_event_message_list}-end`, onDragEndMessage);
    dragdrop_controller.broadcaster.on(`${drag_event_sidebar_folder}-start`, onDragStartFolder);
    dragdrop_controller.broadcaster.on(`${drag_event_sidebar_folder}-end`, onDragEndFolder);
    dragdrop_controller.broadcaster.on(`${drag_event_message_list}-enter-sidebar`, onDragEnterMessage);
    dragdrop_controller.broadcaster.on(`${drag_event_message_list}-leave-sidebar`, onDragLeaveMessage);

    // cross events
    dragdrop_controller.broadcaster.on(`${drag_event_folder_section}-enter-sidebar`, onDragEnterFolder);
    dragdrop_controller.broadcaster.on(`${drag_event_folder_section}-leave-sidebar`, onDragLeaveFolder);
    dragdrop_controller.broadcaster.on(`${drag_event_folder_section}-drop-sidebar`, onDragDropFolder);

    dragdrop_controller.broadcaster.on(`${drag_event_sidebar_folder}-enter-sidebar`, onDragEnterFolder);
    dragdrop_controller.broadcaster.on(`${drag_event_sidebar_folder}-leave-sidebar`, onDragLeaveFolder);
    dragdrop_controller.broadcaster.on(`${drag_event_sidebar_folder}-drop-sidebar`, onDragDropFolder);
  });

  onUnmounted(() =>{
    dragdrop_controller.broadcaster.destroy(`${drag_event_message_list}-start`, onDragStartMessage);
    dragdrop_controller.broadcaster.destroy(`${drag_event_message_list}-end`, onDragEndMessage);
    dragdrop_controller.broadcaster.destroy(`${drag_event_sidebar_folder}-start`, onDragStartFolder);
    dragdrop_controller.broadcaster.destroy(`${drag_event_sidebar_folder}-end`, onDragEndFolder);
    dragdrop_controller.broadcaster.destroy(`${drag_event_message_list}-enter-sidebar`, onDragEnterMessage);
    dragdrop_controller.broadcaster.destroy(`${drag_event_message_list}-leave-sidebar`, onDragLeaveMessage);

    // cross events
    dragdrop_controller.broadcaster.destroy(`${drag_event_folder_section}-enter-sidebar`, onDragEnterFolder);
    dragdrop_controller.broadcaster.destroy(`${drag_event_folder_section}-leave-sidebar`, onDragLeaveFolder);
    dragdrop_controller.broadcaster.destroy(`${drag_event_folder_section}-drop-sidebar`, onDragDropFolder);

    dragdrop_controller.broadcaster.destroy(`${drag_event_sidebar_folder}-enter-sidebar`, onDragEnterFolder);
    dragdrop_controller.broadcaster.destroy(`${drag_event_sidebar_folder}-leave-sidebar`, onDragLeaveFolder);
    dragdrop_controller.broadcaster.destroy(`${drag_event_sidebar_folder}-drop-sidebar`, onDragDropFolder);
  });

  const setCollectionLists = () => {
    folders_collapse_collection.setFolders(folders_controller.mailboxes.folders.custom);
  }

  const onFolderMainContextAction = () => {
    context_folder_component.value.show(true);
  }

  const setTopFolder = () => {
    top_folder_item.value = folders_collapse_collection.getTopFolderItem();
  }

  const onFolderContextMenu = (folder) => {
    setContextFolder(folder);
    context_menu_component.value.show(folder);
  }

  const onSubFoldersToggle = () => {
    (layout_controller.menu_folders_collapsed === true)
      ? subFoldersOpen()
      : subFoldersClose();
  }

  const onDragStartMessage = () => {
    if (layout_controller.menu_collapsed === true) {
      setMenuHideState(true);
      mainMenuOpen();
    }

    if (layout_controller.menu_folders_collapsed === true) {
      setFoldersCollapseState(true);
      subFoldersOpen();
    }
  }

  const onDragStartFolder = (drag_item) => {
    dragdrop_controller.setDragOverlayElement(ref_dragdrop_folders.value.$el);
    dragdrop_controller.setDragOverlayImage(drag_item.element_event);
    drag_item.data.add(drag_item.initial_data.id, drag_item.initial_data);

    setFoldersDisabled(folders_controller.getDisabledFolders(drag_item.initial_data));
  }

  const onDragEndMessage = () => {
    if (folders_collapse_state.value === true) {
      subFoldersClose();
      setFoldersCollapseState(false);
    }

    if (menu_hide_state.value === true) {
      mainMenuClose();
      setMenuHideState(false);
    }
  }

  const onDragEndFolder = () => {
    setFoldersDisabled({});
  }

  const onDragEnterMessage = (drag_item) => {
    folders_collapse_collection.expandDelay(drag_item.drop_data.id);

  }

  const onDragLeaveMessage = (drag_item) => {
    folders_collapse_collection.expandDelayStop(drag_item.drop_data.id);;
  }

  const onDragEnterFolder = (drag_item) => {
    folders_collapse_collection.expandDelay(drag_item.drop_data.id);

  }

  const onDragLeaveFolder = (drag_item) => {
    folders_collapse_collection.expandDelayStop(drag_item.drop_data.id);
  }

  const onDragDropFolder = (drag_item) => {
    folders_controller.move(
      drag_item.drop_data,
      drag_item.initial_data
    );
  }

  const setFoldersDisabled = (value) => {
    folders_disabled.value = value;
  }

  const setFoldersCollapseState = (value) => {
    folders_collapse_state.value = value;
  }

  const setMenuHideState = (value) => {
    menu_hide_state.value = value;
  }

  const onDismissMenu = () => {
    layout_controller.menu_toggled = false;
  }

  const onWriteCompose = () => {
    router.push("/compose");
  }

  const setContextFolder = (folder) => {
    context_folder.value = folder;
  }

  const mainMenuOpen = () => {
    layout_controller.menu_collapsed = false;
  }

  const mainMenuClose = () => {
    layout_controller.menu_collapsed = true;
  }

  const subFoldersOpen = () => {
    layout_controller.menu_folders_collapsed = false;
    layout_controller.menu_collapsed         = false;
  }

  const subFoldersClose = () => {
    layout_controller.menu_folders_collapsed = true;
  }
</script>